export default class UpdateMarkerThumbnailModel {
    organizationId = null;
    assetId = null;
    scanId = null;
    id = null;
    base64Image = null;
    fileExtension = null;

    constructor(organizationId, assetId, id, base64Image, fileExtension, scanId = null){
        this.organizationId = organizationId;
        this.assetId = assetId;
        this.scanId = scanId;
        this.id = id;
        this.base64Image = base64Image;
        this.fileExtension = fileExtension;
    }
}